var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('v-row',[_c('v-col',[_c('BannerItem',_vm._b({},'BannerItem',_vm.bannerItems[0],false))],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }